export const TAG_COLORS = {
  'Hiking': '#C1E1C1',       // Pastel Green
  'Scrambling': '#FFDAC1',   // Pastel Peach
  'Glacier travel': '#A2E1DB', // Pastel Cyan/Blue
  'Ice climbing': '#B5EAD7', // Mint
  'Via ferrata': '#FFB7B2',  // Pastel Red/Pink
};

const DEFAULT_COLOR = '#E0E0E0'; // Light Grey

export const getTagStyle = (tag) => {
  const backgroundColor = TAG_COLORS[tag] || DEFAULT_COLOR;
  return {
    backgroundColor,
    color: '#333333' // Dark text for contrast on pastel
  };
};
